import { Component, OnInit, Input } from '@angular/core';
import { ChartType, ChartColor, ChartOptions } from 'chart.js';
import { SingleDataSet, Label, Color } from 'ng2-charts';
import { ObservatoryService, StorageService, FileExporterService } from '@services/services.module';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { CalendarService } from '@components/calendar/calendar.service';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { DayData, ImputationsData } from '@components/calendar/calendar-day/calendar-day.model';
import { NotificationsService } from '@services/notifications/notifications.service'

@Component({
  selector: 'app-donut-charts',
  templateUrl: './donut-charts.component.html',
  styleUrls: ['./donut-charts.component.scss']
})
export class DonutChartsComponent implements OnInit {
  constructor(
    private observatory: ObservatoryService,
    public translate: TranslateService,
    public fileExporter: FileExporterService,
    public calendarService: CalendarService,
    private storage: StorageService,
    public calendar: NgbCalendar,
    private notification: NotificationsService,
  ) { 
    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.doughnutChartLabels= [this.translate.instant('HNOIMP'), this.translate.instant('HIMP')];
    });
  }
  public amountHoursS1;
  public dataJson: any;
  public userData: any;
  public doughnutChartLabels: Label[] = [this.translate.instant('HNOIMP'), this.translate.instant('HIMP')];
  public doughnutChartData: SingleDataSet = [];
  public doughnutChartType: ChartType = 'doughnut';
  public donutColors = [
    {
      backgroundColor: ['rgba(231, 131, 45, 1)', 'rgba(56, 96, 151, 1)']
    }
  ];
  public doughnutChartOptions: any = {
    responsive: true,
    legend: {
      onClick: () => {
        return false;
      }
    }
  };

  ngOnInit() {
    this.amountHoursS1 = 0;
    this.observatory.getData('horasGrafico').subscribe(val => {
      this.amountHoursS1 = 0;
      this.dataJson = val;
      if (!!this.dataJson.activityTypeS1) {
        this.dataJson.activityTypeS1.forEach(s => {
          this.amountHoursS1 += Number(s.hours);
        }),
          (this.doughnutChartData = [this.dataJson.totalHours - this.amountHoursS1, this.amountHoursS1]);
        this.amountHoursS1 = 0;
      } else {
        this.doughnutChartData = [this.dataJson.totalHours, 0];
      }
    });
  }

}
